'use client';

import React from 'react';
import Link from 'next/link';
import { Bot, ArrowLeft, LayoutDashboard, History, TrendingUp, FlaskConical, Settings } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col items-center justify-center p-6 relative overflow-hidden bg-grid-pattern">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 left-1/2 -translate-x-1/2 w-80 h-80 bg-purple-600/10 rounded-full blur-3xl pointer-events-none" />

      <div className="glass-card max-w-lg w-full p-8 sm:p-10 rounded-3xl border border-slate-800 bg-slate-900/90 shadow-2xl text-center space-y-6 relative z-10">
        {/* Logo badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 border border-slate-700/80 text-blue-400 font-semibold text-xs uppercase tracking-wider shadow-inner">
          <Bot className="w-4 h-4" />
          Moah AI Trader
        </div>

        {/* 404 Code */}
        <div className="space-y-2">
          <h1 className="text-7xl font-black bg-gradient-to-r from-blue-400 via-indigo-300 to-purple-400 bg-clip-text text-transparent font-mono tracking-tight">
            404
          </h1>
          <h2 className="text-xl font-bold text-slate-100">Page Not Found</h2>
          <p className="text-sm text-slate-400 max-w-sm mx-auto leading-relaxed">
            The algorithmic path you requested was not found or has been moved to a different market endpoint.
          </p>
        </div>

        {/* Quick Links */}
        <div className="pt-2 border-t border-slate-800/80">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">
            Quick Navigation
          </p>
          <div className="grid grid-cols-2 gap-2 text-left">
            <Link
              href="/dashboard"
              className="flex items-center gap-2 p-2.5 rounded-xl bg-slate-800/50 hover:bg-slate-800 border border-slate-700/50 text-slate-300 hover:text-white transition-all text-xs font-medium"
            >
              <LayoutDashboard className="w-4 h-4 text-blue-400" />
              Dashboard
            </Link>
            <Link
              href="/trades"
              className="flex items-center gap-2 p-2.5 rounded-xl bg-slate-800/50 hover:bg-slate-800 border border-slate-700/50 text-slate-300 hover:text-white transition-all text-xs font-medium"
            >
              <History className="w-4 h-4 text-emerald-400" />
              Trades Log
            </Link>
            <Link
              href="/performance"
              className="flex items-center gap-2 p-2.5 rounded-xl bg-slate-800/50 hover:bg-slate-800 border border-slate-700/50 text-slate-300 hover:text-white transition-all text-xs font-medium"
            >
              <TrendingUp className="w-4 h-4 text-amber-400" />
              Performance
            </Link>
            <Link
              href="/settings"
              className="flex items-center gap-2 p-2.5 rounded-xl bg-slate-800/50 hover:bg-slate-800 border border-slate-700/50 text-slate-300 hover:text-white transition-all text-xs font-medium"
            >
              <Settings className="w-4 h-4 text-purple-400" />
              Settings
            </Link>
          </div>
        </div>

        {/* Back Button */}
        <div className="pt-2">
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm transition-all shadow-lg shadow-blue-600/25 active:scale-95"
          >
            <ArrowLeft className="w-4 h-4" />
            Return to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
